import { Stack } from '../../design-system/stack/stack';
import Header from '../layout/header';
import { ManageMembers } from './components/manage-members';

export const ManageMembersPage = () => {
  return (
    <Stack align="stretch" className="min-h-screen p-2.5">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-lg bg-white">
        <Header />
        <ManageMembers />
      </Stack>
    </Stack>
  );
};
